class Config {
  static getEnvironment() {
    return process.env.REACT_APP_ENV || 'development'
  }

  static getBaseUrl() {
    if (this.isProd()) {
      return 'https://www.epharma.dghealthcare.online/api/pharmacystore/'
    }

    if (this.isUat()) {
      return 'https://www.epharma-uat.dghealthcare.online/api/pharmacystore/'
    }

    if (this.isDev()) {
      // return 'http://103.52.140.82:8000/api/pharmacystore/'
      return 'http://localhsot:8000/api/pharmacystore/'
    }

    return 'http://localhost:8000/api/pharmacystore/'
  }

  static getCrmBaseUrl() {
    return this.getBaseUrl().replace('/api/pharmacystore/', '/api/crm/')
  }

  static getMediaBaseUrl() {
    if (this.isProd()) {
      return 'https://www.epharma.dghealthcare.online'
    }

    if (this.isUat()) {
      return 'https://www.epharma-uat.dghealthcare.online'
    }

    if (this.isDev()) {
      return 'https://www.epharma-dev.dghealthcare.online'
    }

    return 'http://localhost:8000'
  }

  static getFullImageUrl(imagePath) {
    if (!imagePath) return ''
    if (imagePath.startsWith('http')) return imagePath
    
    const baseUrl = this.getMediaBaseUrl()
    
    let cleanPath = imagePath
    if (!cleanPath.startsWith('/media/') && !cleanPath.startsWith('media/')) {
      cleanPath = `/media/${cleanPath}`
    } else if (cleanPath.startsWith('media/')) {
      cleanPath = `/${cleanPath}`
    } else if (!cleanPath.startsWith('/')) {
      cleanPath = `/${cleanPath}`
    }
    
    return `${baseUrl}${cleanPath}`
  }

  static isDev() {
    const env = this.getEnvironment()
    return env === 'dev'
  }

  static isUat() {
    const env = this.getEnvironment()
    return env === 'uat'
  }

  static isProd() {
    const env = this.getEnvironment()
    return env === 'prod'
  }
}

export default Config
